import React from "react";
import { ButtonSingle } from "../../../../../widget/common/form/Button";
import AppTranslation from "../../../../../service/app_translation/AppTranslation";
import { navigate } from "../../../../../service/navigation/Navigation";
import { appRoutes } from "../../../../../routes/routes";
import Div from "../../../../../widget/common/ui/Div";
import { SignupPersonalInformationContextImport } from "../../../../../provider/onboarding/signup/personal_information/SignupPersonalInformationContextProvider";
import { ResponsiveDeviceType } from "../../../../../widget/layouts/ScreenMedia";

const SignupPersonalInformationButtons = (props: {
  type?: number | undefined;
}) => {
  const type: number = props.type ?? ResponsiveDeviceType();
  const { submitDetail } = SignupPersonalInformationContextImport();

  return (
    <Div>
      <Div className="pb-2">
        <ButtonSingle
          handleClick={() => submitDetail()}
          width={300}
          processing={false}
        >
          {AppTranslation.text("next")}
        </ButtonSingle>
      </Div>
      {type === 3 && (
        <Div>
          <ButtonSingle
            handleClick={() =>
              navigate(appRoutes.routeNameLogin, { replace: true })
            }
            width={300}
            textColor="theme-sublabel"
            bgColor="trans"
            fontSize="16_17"
            fontName="book"
          >
            {AppTranslation.text("exit_without_saving")}
          </ButtonSingle>
        </Div>
      )}
    </Div>
  );
};

export default SignupPersonalInformationButtons;
